import { type WorkspaceTemplateConfig } from '~/components/Modals/BoardTemplateModal/types';

const getCurrentYear = () => new Date().getFullYear();

export const AGENCY_TEMPLATE: WorkspaceTemplateConfig = {
  id: 'agency',
  title: 'Agency',
  description: 'Manage client projects and feedback in one place.',
  boards: [
    {
      title: 'Clients',
      subBoards: [
        {
          title: 'Client Template',
          subBoards: [
            { title: 'Brand Assets' },
            {
              title: 'Campaigns',
              subBoards: [
                {
                  title: `Spring ${getCurrentYear()} Campaign`,
                  subBoards: [{ title: 'Concepts' }, { title: 'Working Files' }, { title: 'Final Deliverables' }],
                },
                {
                  title: `Holiday ${getCurrentYear()} Campaign`,
                  subBoards: [{ title: 'Concepts' }, { title: 'Working Files' }, { title: 'Final Deliverables' }],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      title: 'Agency Portfolio',
      subBoards: [
        { title: 'Case Studies' },
        { title: 'Highlight Reels' },
        { title: "Best Of's / Inspiration" },
        { title: 'Agency Campaigns (Own Brand)' },
        { title: 'PR & Events' },
      ],
    },
    {
      title: 'Brand Guidelines',
      subBoards: [
        { title: 'Agency Logos' },
        { title: 'Guidelines Document' },
        { title: 'Fonts' },
        { title: 'Color Palettes' },
        { title: 'Templates (Decks, Proposals, Contracts)' },
      ],
    },
    {
      title: 'Operations',
      subBoards: [
        { title: 'Contracts & SOWs' },
        { title: 'Training Resources' },
        { title: 'Internal Presentations' },
        { title: 'Knowledge Base' },
      ],
    },
    {
      title: 'Archive',
      subBoards: [{ title: 'Past Clients' }],
    },
  ],
};
